export function generateNewId() {
  return new Date().getTime()
}
